import { DropdownMenuItem } from "@/components/podkit/dropdown/DropDown";
import { DropdownActions } from "@/components/podkit/dropdown/DropDownActions";
import { useState } from "react";
import type { FC } from "react";
import { DeleteAgentExecutionModal } from "@/components/ai/DeleteAgentExecutionModal";
import { ViewTranscriptModal } from "@/components/ai/ViewTranscriptModal";
import type { PlainAgentExecution } from "@/queries/agent-queries";
import { Button } from "@/components/flexkit/Button";
import { IconChevronDownSmall } from "@/assets/icons/geist/IconChevronDownSmall";
import { AgentExecution_Phase } from "gitpod-next-api/gitpod/v1/agent_pb";
import { useAgentExecutionActions } from "@/hooks/use-agent-execution-actions";

export const AgentExecutionDropdownMenu: FC<{ agentExecution: PlainAgentExecution }> = ({ agentExecution }) => {
    const [showDeleteAgentExecutionModal, setShowDeleteAgentExecutionModal] = useState(false);
    const [showViewTranscriptModal, setShowViewTranscriptModal] = useState(false);
    const { copyAgentExecutionId, handleStopAgentExecution } = useAgentExecutionActions(agentExecution);

    return (
        <>
            <DropdownActions
                triggerTestId="agent-execution-options-trigger"
                button={
                    <Button
                        size="sm"
                        variant="ghost"
                        className="border-0"
                        aria-label="More actions"
                        LeadingIcon={IconChevronDownSmall}
                    />
                }
            >
                <DropdownMenuItem data-testid="menu-item-copy-agent-execution-id" onClick={copyAgentExecutionId}>
                    Copy agent execution ID
                </DropdownMenuItem>
                <DropdownMenuItem
                    data-testid="menu-item-view-transcript"
                    onClick={() => setShowViewTranscriptModal(true)}
                >
                    View transcript
                </DropdownMenuItem>
                <DropdownMenuItem
                    data-testid="menu-item-stop-agent-execution"
                    onClick={handleStopAgentExecution}
                    disabled={agentExecution.status?.phase === AgentExecution_Phase.STOPPED}
                >
                    Stop agent execution
                </DropdownMenuItem>
                <DropdownMenuItem
                    className="text-content-red focus:text-content-red"
                    data-testid="menu-item-delete-agent-execution"
                    onClick={() => {
                        setShowDeleteAgentExecutionModal(true);
                    }}
                >
                    Delete agent execution
                </DropdownMenuItem>
            </DropdownActions>
            <DeleteAgentExecutionModal
                agentExecution={agentExecution}
                open={showDeleteAgentExecutionModal}
                onClose={() => setShowDeleteAgentExecutionModal(false)}
            />
            <ViewTranscriptModal
                agentExecution={agentExecution}
                open={showViewTranscriptModal}
                onClose={() => setShowViewTranscriptModal(false)}
            />
        </>
    );
};
